import { createFileRoute } from "@tanstack/react-router";
import AdminImportRequests from "@/pages/admin/ImportRequests";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/import-requests/")({
  head: () => routeHead("/admin/import-requests/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminImportRequests />
  );
}
